/* eslint-disable no-param-reassign */
import getLocaleMixins from '../../utils/getLocaleMixins';
import addSealRtcReceivers from '../../dialog/seal-rtc/add-receiver';
import avatar from '../avatar.vue';
import userProfile from '../../dialog/contact/user';
import config from '../../config';
import validate from '../mixins/validate';

const immediately = 'Immediately';
export default {
    name: 'seal-RTC',
    data() {
        return {
            subject: '',
            rtcId: roundNum(10),
            receivers: [],
            selectedTime: immediately,
            isSpecificTimeSelecting: false,
            isSending: false,
        };
    },
    components: {
        avatar,
    },
    mixins: [getLocaleMixins('seal-RTC'), validate()],
    mounted() {
        const im = this.$im();
        if (im.loginUser) {
            this.subject = im.loginUser.name + this.locale.metting;
        }
    },
    methods: {
        userProfile,
        addMembers() {
            addSealRtcReceivers(this.receivers, this.receivers).done(
                (selectedReceivers) => {
                    this.receivers = selectedReceivers;
                },
            );
        },
        getSelectedTime() {
            if (this.selectedTime === immediately) {
                return config.currentLocale().components.sealRTC.now;
            }
            const date = new Date(this.selectedTime);
            return formatDate(null, date);
        },
        selectSpecificTime() {
            if (
                Object.prototype.toString.call(this.selectedTime) !== '[object Number]'
            ) {
                const date = new Date();
                date.setMilliseconds(0);
                date.setSeconds(0);
                this.selectedTime = date.getTime();
            }
            this.isSpecificTimeSelecting = true;
        },
        getDateItems() {
            const locale = config.currentLocale().components.newPin;
            return [locale.year, locale.month, locale.day, locale.hour, locale.minute];
        },
        getFormatDate(type) {
            const date = new Date(this.selectedTime);
            return formatDate(type, date);
        },
        calcDate,
        closeSelectTime(event) {
            const $target = $(event.target);
            const wrap = '.position-right, .rong-pin-select-time, .rong-pin-select-sepcific-time, .rong-pin-select-time-box, .rong-pin-select-type-box';
            const inBody = $target.closest('body').length > 0;
            const inWrap = $target.closest(wrap).length < 1;
            const isOuter = inBody && inWrap;
            if (this.isSpecificTimeSelecting && isOuter) {
                this.isSpecificTimeSelecting = false;
            }
        },
        removeReceiver(index) {
            this.receivers.splice(index, 1);
        },
        executiveLimit(item) {
            if (
                item.isFriend
           || this.$im().auth.isExecutive
            // this.disableExecutive
            ) {
                return false;
            }
            const isExecutive = !!item.isExecutive;
            return isExecutive;
        },
        sendPinMeeting() {
            if (this.isSending || !this.valid()) {
                return;
            }
            this.isSending = true;
            sendPin(this);
        },
        joinPinMeeting() {
            this.$im().$emit('openSealRtc', '');
        },
    // maxCountLimit() {
    //     const mostReceiveFormat = config.currentLocale().components.newPin
    //         .mostReceive;
    //     const hintMessage = this.localeFormat(
    //         mostReceiveFormat,
    //         this.maxReceiverCount
    //     );
    //     this.toast({
    //         type: "error",
    //         message: hintMessage
    //     });
    //     this.reset();
    // }
    },
    watch: {
        $route() {
            const im = this.$im();
            im.RongIM.common.resizeNavNode(this);
        },
    },
};

function sendPin(context) {
    const im = context.$im();
    const params = getSendParams(context);
    const pinApi = im.dataModel.Pin;
    pinApi.create(params, (errorCode) => {
        if (errorCode) {
            im.RongIM.common.toastError(errorCode);
            context.isSending = false;
            return;
        }
        im.RongIM.common.messageToast({
            message: context.locale.sendPinSuccess,
            type: 'success',
            callback: () => {
                context.subject = '';
                context.rtcId = '';
                context.receivers = [];
                context.isSending = false;
            },
        });
    });
}

function getSendParams(context) {
    const reveiverIds = context.receivers
        .filter(item => !context.executiveLimit(item))
        .map(reveiver => reveiver.id);
    const delayed = Object.prototype.toString.call(context.selectedTime) === '[object Number]';
    const params = {
        content: getSendContent(context),
        receiver_ids: reveiverIds,
        delayed,
        send_sms: context.isSendSms,
    };
    params.delayed_send_time = delayed ? context.selectedTime : '';
    return params;
}

function getSendContent(context) {
    const date = formatDate(
        null,
        context.selectedTime === immediately
            ? new Date()
            : new Date(context.selectedTime),
    );
    const content = `${context.locale.pinTitle}\r\n${context.locale.subject}: ${context.subject}\r\n${context.locale.startTime}: ${date}\r\n${context.locale.id}: rtc://${context.rtcId}${context.locale.clickLink}`;
    return content;
}

function calcDate(dateType, addNumber) {
    const date = new Date(this.selectedTime);
    switch (dateType) {
    case 0:
        date.setFullYear(date.getFullYear() + addNumber);
        break;
    case 1:
        date.setMonth(date.getMonth() + addNumber);
        break;
    case 2:
        date.setDate(date.getDate() + addNumber);
        break;
    case 3:
        date.setHours(date.getHours() + addNumber);
        break;
    case 4:
        date.setMinutes(date.getMinutes() + addNumber);
        break;
    default:
        break;
    }
    const thisTime = new Date().getTime();
    if ((thisTime - date.getTime()) > 30 * 1000) {
        this.$im().RongIM.common.messageToast({
            type: 'error',
            message: config.currentLocale().components.newPin.pastTime,
        });
        return;
    }
    date.setSeconds(0);
    date.setMilliseconds(0);
    this.selectedTime = date.getTime();
}

function addZeroWhenSingle(number) {
    return `${number}`.length > 1 ? number : `0${number}`;
}

function formatDate(type, date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    switch (type) {
    case 0:
        return year;
    case 1:
        return month;
    case 2:
        return day;
    case 3:
        return hour;
    case 4:
        return minute;
    default:
        return `${year}/${month}/${day} ${addZeroWhenSingle(
            hour,
        )}:${addZeroWhenSingle(minute)}`;
    }
}

function roundNum(n) {
    let round = '';
    for (let i = 0; i < n; i += 1) {
        round += Math.floor(Math.random() * 10);
    }
    return round;
}
